// Session-wide ephemeral presence (tab visibility + reconnect).

import type { PresenceState } from '@ping/ui/src/ephemeral';

import { log } from '@core/log/log';

import { getCurrentEphemeralClient } from './ephemeralSession';

let visibilityBound = false;

function desiredPresenceFromDocument(): PresenceState {
  if (typeof document === 'undefined') return 'online';
  return document.hidden ? 'away' : 'online';
}

export function syncEphemeralPresenceState(state?: PresenceState): void {
  const client = getCurrentEphemeralClient();
  if (client == null) return;
  const next = state ?? desiredPresenceFromDocument();
  void client.publishPresenceToSubscribed(next).catch(() => {
    log.debug({ event: 'ephemeralSession.presence.sync_failed' });
  });
}

export function bindEphemeralPresenceLifecycle(): void {
  if (visibilityBound || typeof document === 'undefined') return;
  visibilityBound = true;

  const onVisibility = (): void => {
    syncEphemeralPresenceState();
  };

  document.addEventListener('visibilitychange', onVisibility);
  window.addEventListener('pagehide', () => {
    syncEphemeralPresenceState('offline');
  });
}

export function unbindEphemeralPresenceLifecycle(): void {
  visibilityBound = false;
}
